import { Authenticator } from "@aws-amplify/ui-react"
import { ThemeProvider } from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { ConfirmProvider } from "material-ui-confirm"
import { ReactElement, useEffect } from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"

// eslint-disable-next-line import/no-unresolved
import "@aws-amplify/ui-react/styles.css"

import "./webpageFrame/appHeight"
import "./index.css"

import App from "./app"
import { useGetState } from "./hooks/useGetState"
import { UserDataProvider } from "./providers/userDataProvider"
import { DARK, getTheme } from "./redux/preferencesSlice"
import { store } from "./redux/store"
import reportWebVitals from "./reportWebVitals"
import darkTheme from "./themes/darkTheme"
import lightTheme from "./themes/lightTheme"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

/**
 * Component housing all application-level wrappers. Injected into rect
 * root node.
 */
const ApplicationWrappers = (): ReactElement => {
    const uiTheme = useGetState(getTheme)

    // Set the theme color meta tag to the background color of the current theme required for mobile)
    useEffect(() => {
        const themeColor = document.querySelector('meta[name="theme-color"]')
        if (themeColor) {
            if (uiTheme === DARK) {
                themeColor.setAttribute(
                    "content",
                    darkTheme.palette.background.frameBackground
                )
            } else {
                themeColor.setAttribute(
                    "content",
                    lightTheme.palette.background.contentBackground
                )
            }
        }
    }, [uiTheme])
    return (
        <Authenticator.Provider>
            <ThemeProvider theme={uiTheme === DARK ? darkTheme : lightTheme}>
                <BrowserRouter>
                    <UserDataProvider>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ConfirmProvider>
                                <App />
                            </ConfirmProvider>
                        </LocalizationProvider>
                    </UserDataProvider>
                </BrowserRouter>
            </ThemeProvider>
        </Authenticator.Provider>
    )
}
root.render(
    // <React.StrictMode>
    <Provider store={store}>
        <ApplicationWrappers />
    </Provider>
    // </React.StrictMode>
)

reportWebVitals()
